export const MODAL_TYPES = {
  VERIFY: 'VERIFY',
  VALID: 'VALID',
  INVALID: 'INVALID',
};

export const REQUIRED_FIELDS = ['latitude', 'longitude'];
